import dayjs, { Dayjs } from 'dayjs'

import { TimePickerHelpers } from '@percent/domain/giving'

const getTime = (time: string): [number, number] => {
  const formattedTime = TimePickerHelpers.convertTo24HourFormat(time)
  const splitTime = formattedTime.split(':').map(timeValue => parseInt(timeValue, 10))

  if (splitTime.length !== 2 || splitTime.some(value => typeof value !== 'number')) {
    throw new Error('Invalid time value')
  }

  return splitTime as [number, number]
}

export const getDateFromDateAndTime = (date: Date, time: string) => {
  const timeValues = getTime(time)

  return dayjs(date).hour(timeValues[0]).minute(timeValues[1]).toDate()
}

export const getTimeFromDate = (date?: Dayjs) => {
  if (!date) {
    return ''
  }
  const is12HrsFormat = TimePickerHelpers.is12hourFormat()
  const time = date.format('HH:mm')

  return is12HrsFormat ? TimePickerHelpers.convertTo12HourFormat(time) : time
}
